import React, { useState } from "react";
import API from "../api";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const nav = useNavigate();

  const login = async (e) => {
    e.preventDefault();

    const res = await API.post("/auth/login", {
      username,
      password,
    });

    localStorage.setItem("token", res.data.token);

    nav("/admin/dashboard");
  };

  return (
    <div className="login-box">
      <h2>Admin Login</h2>

      <form onSubmit={login}>
        <input
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />

        <button>Login</button>
      </form>
    </div>
  );
}